import CarSpec from "./CarSpec";

export default CarSpec;
